const SkipToContent = ({ targetId = 'main-content' }) => (
  <a
    href={`#${targetId}`}
    className="fixed left-4 top-4 z-[100] -translate-y-24 rounded-full bg-rastyle-orange px-4 py-2 font-semibold text-black transition-transform focus:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white motion-reduce:transition-none"
  >
    Skip to main content
  </a>
);

export default SkipToContent;
